import React, { FC } from 'react';
import { PageContainer } from '../../components/base/pageContainer/pageContainer';
import SearchLandingPage from '../../components/search-v2/searchLandingPage';
import pageWrapper from '../../hoc/pageWrapper';
import IPageViewModel from '../../interfaces/umbracoNodes/pageViewModel';

interface ISearchPageViewModel extends IPageViewModel {
	Values: {
		Title: string;
		InputPlaceholder: string;
	};
}

interface Props {
	page: ISearchPageViewModel;
}

const Search: FC<Props> = ({ page }) => {
	return (
		<PageContainer>
			<SearchLandingPage title={page.Values.Title} inputPlaceholder={page.Values.InputPlaceholder} />
		</PageContainer>
	);
};

export default pageWrapper(Search);
